<div class="pricefx-loader-container">
  <form class="coverageReportForm">
    <div class="plRegSelection">

      <div class="formControl">
        <label class="formLabel required" for="email">
          Regions
        </label>

        <div class="toggleCont">
          <p (click)="openReg()">{{selectedRegions().length ? selectedRegions() : 'Select Region'}}
          </p>
          <div class="optionsSet" *ngIf="isRegionOpen">
            <label for="{{region.regionCode}}" class="optionBtn" [ngClass]="{'checked': selectedRegions().includes(region.regionName)}"
              *ngFor="let region of regions">
              <input type="checkbox" [checked]="selectedRegions().includes(region.regionCode)"
                id="{{region.regionCode}}" (change)="toggleRegionSelection(region.regionName)" />
              {{ region.regionName }}
            </label>
          </div>
        </div>
        <img src="/assets/images/chevron-south.svg" (click)="openReg()" alt="email-icon" class="emailIcon">
      </div>
      <div class="formControl">
        <label class="formLabel required" for="email">
          Product Line
        </label>
        <div class="toggleCont" [class.disabled]="isPLDisabled">
          <p (click)="openPL()">{{selectedProductLineIds().length ? selectedProductLineIds() : 'Select
            Productline'}}</p>
          <div class="optionsSet" *ngIf="isPLOpen">
            <label for="{{productLine.code}}" class="optionBtn"
              [ngClass]="{'checked': selectedProductLineIds().includes(productLine.description)}" *ngFor="let productLine of productLines">
              <input type="checkbox" [checked]="selectedProductLineIds().includes(productLine.description)"
                id="{{productLine.code}}" (change)="togglePLSelection(productLine.description)" />
              {{ productLine.description }}
            </label>
          </div>
        </div>
        <img (click)="openPL()" src="/assets/images/chevron-south.svg" alt="email-icon" class="emailIcon">
      </div>

      <div class="formControl">
        <div class="sorting_dropdowns_div" style="margin-top: -15px;">
          <div class="valid_from_date_div dropdown_div">
            <div class="title">
              Valid From Date
            </div>
            <div class="dropdown calendar">
              <input type="text" readonly="true" placeholder="Select Valid From Date" [(ngModel)]="validFromDate"
                [ngModelOptions]="{standalone: true}" onKeyPress="" (click)="onMonthPickerOpen()"
                [ngClass]="{
                      open_btn: true
                    }" />
              <div class="calendar-svg" onKeyPress="" (click)="onMonthPickerOpen()">
                <img src="../../../../assets/images/calendar.svg" alt="calendar" />
              </div>
              <month-picker style="position: absolute !important;" (monthRangeSelected)="logRange2($event)" [validFromDateFlag]="validFromDateFlag" [priceDateFlag]="false"
                *ngIf="isValidFromDateVisible"></month-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="reqSelectionCont">
      <h3>Select 2 pairing reports to Generate the final pairing file to load in PfX</h3>
      <div class="formControl">
         <label class="formLabel required" for="email">
          Base Pairing Request <span>(Select an existing report from dropdown OR Upload New)</span>
        </label>
        <div class="toggleCont" [class.disabled]="isPR1Disabled">
          <p (click)="openPR1()"><span *ngIf="selectedPR1()">{{selectedPR1()?.requestId}}</span>
            &nbsp;&nbsp;{{selectedPR1()?.label || 'Select a pairing request'}}</p>
          <div class="optionsSet" *ngIf="isPR1Open">
            <label for="{{pairReq.requestId}}" class="optionBtn"
              [ngClass]="{'checked': selectedPR1()?.requestId === pairReq.requestId}"
              *ngFor="let pairReq of requstList">
              <input type="radio" name="pr1" id="{{pairReq.requestId}}" [value]="pairReq.requestId"
                [checked]="selectedPR1()?.requestId === pairReq.requestId"
                (change)="togglePR1Selection(pairReq.requestId); $event.stopPropagation()" />
              <p><span>{{ pairReq.requestId }}</span>{{ pairReq.label }}</p>
            </label>
          </div>
        </div>
        <img (click)="openPR1()" src="/assets/images/chevron-south.svg" alt="email-icon" class="emailIcon">
        <p class="separater">OR</p>
        <div class="download_file_section">
          <div>
            <div class="file_name">Base Pairing Request Template</div>
          </div>

          <div onKeyPress="" (click)="downloadPriceFXFile()" style="cursor: pointer;">
            <img class="download-icon" src="../../assets/images/download.svg" alt="download_icon" />
          </div>
        </div>
        <div class="prUpload" style="border: dashed 1px var(--btn-green) !important;
                        border-radius: 0px !important;
                        background-color: #4db6ac0d !important;">
          <label for="prFile" class="upload-custom-text" style="color: #4db6ac; font-weight: bolder;">
            UPLOAD
          </label>
          <input type="file" id="prFile" #fileInput name="filename1" class="prUploadBtn"
            (change)="onFileSelected($event, 1)">
        </div>
        <div class="progress_div" *ngIf="isFileUploaded1 && !errorFlag1">
          <div class="progress">
            <div class="progress-bar active" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"
              style="width: 100%"></div>
          </div>
          <div>100%</div>
        </div>
        <div class="file_name_div">
          {{ fileName1 }}
        </div>
        <div class="file_name_div" *ngIf="getFileSize1 && !errorFlag1">
          <div class="file_size1">
            Size:
            <span>{{ getFileSize1 | formatFileSize : true }}</span>
          </div>
        </div>
        <div class="validation" *ngIf="errorFlag1">
          <img src="../../assets/images/warning.svg" alt="warning-icon" /><span>{{ fileError1 }}</span>
        </div>

        <div class="success_msg" *ngIf="isFileUploaded1 && !errorFlag1">
          <img src="../../assets/images/sucess-icon.svg" alt="success-icon" width="18px" height="18px" />
          File uploaded successfully
        </div>
      </div>
      <div></div>
      <div class="formControl">
        <label class="formLabel required" for="email">
          New Pairing Request <span>(Select an existing report from dropdown OR Upload New)</span>
        </label>
        <div class="toggleCont" [class.disabled]="isPR2Disabled">
          <p (click)="openPR2()"><span
              *ngIf="selectedPR2()">{{selectedPR2()?.requestId}}</span>&nbsp;&nbsp;{{selectedPR2()?.label
            || 'Select a pairing request'}}</p>
          <div class="optionsSet" *ngIf="isPR2Open">
            <label for="{{pairRequest.requestId}}" class="optionBtn" *ngFor="let pairRequest of requstList">
              <input type="checkbox" id="{{pairRequest.requestId}}"
                (change)="togglePR2Selection(pairRequest.requestId)" />
              <p><span>{{pairRequest.requestId}}</span>{{ pairRequest.label }}</p>
            </label>
          </div>
        </div>
        <img (click)="openPR2()" src="/assets/images/chevron-south.svg" alt="email-icon" class="emailIcon">
        <p class="separater">OR</p>
        <div class="download_file_section">
          <div>
            <div class="file_name">New Pairing Request Template</div>
          </div>

          <div onKeyPress="" (click)="downloadPriceFXFile()" style="cursor: pointer;">
            <img class="download-icon" src="../../assets/images/download.svg" alt="download_icon" />
          </div>
        </div>
        <div class="prUpload" style="border: dashed 1px var(--btn-green) !important;
                        border-radius: 0px !important;
                        background-color: #4db6ac0d !important;">
          <label for="prFile" class="upload-custom-text" style="color: #4db6ac; font-weight: bolder;">
            UPLOAD
          </label>
          <input type="file" id="prFile" #fileInput name="filename2" class="prUploadBtn"
            (change)="onFileSelected($event, 2)">
        </div>
        <div class="progress_div" *ngIf="isFileUploaded2 && !errorFlag2">
          <div class="progress">
            <div class="progress-bar active" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"
              style="width: 100%"></div>
          </div>
          <div>100%</div>
        </div>
        <div class="file_name_div" *ngIf="isFileUploaded2 && !errorFlag2">
          {{ fileName2 }}
        </div>
        <div class="file_name_div" *ngIf="getFileSize2 && !errorFlag2">
          <div class="file_size">
            Size:
            <span>{{ getFileSize2 | formatFileSize : true }}</span>
          </div>
        </div>
        <div class="validation" *ngIf="errorFlag2">
          <img src="../../assets/images/warning.svg" alt="warning-icon" /><span>{{ fileError2 }}</span>
        </div>

        <div class="success_msg" *ngIf="isFileUploaded2 && !errorFlag2">
          <img src="../../assets/images/sucess-icon.svg" alt="success-icon" width="18px" height="18px" />
          File uploaded successfully
        </div>
      </div>
    </div>
    <div class="ctaCont">
      <button class="primary" type="button" (click)="reqSubmit()" [disabled]="isSubmitDisabled">
        GENERATE PRICEFX REQUEST
      </button>
    </div>
  </form>
  <app-toast [message]="popupMessage" [isSuccess]="isSuccessToast" *ngIf="isShowErrorMessageWithToast"></app-toast>
</div>